import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const ThreeDotsCircle = forwardRef<SVGSVGElement, SvgIconProps>(
  function ThreeDotsCircle(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="m12 23.979c-6.6157 0-11.979-5.3631-11.979-11.979s5.3631-11.979 11.979-11.979 11.979 5.3631 11.979 11.979-5.3631 11.979-11.979 11.979zm0-2.6619c5.1455 0 9.3168-4.1713 9.3168-9.3168s-4.1713-9.3168-9.3168-9.3168-9.3168 4.1713-9.3168 9.3168 4.1713 9.3168 9.3168 9.3168zm-5.3239-7.9858c-0.73507 0-1.331-0.5959-1.331-1.331 0-0.73507 0.5959-1.331 1.331-1.331 0.73507 0 1.331 0.5959 1.331 1.331 0 0.73507-0.5959 1.331-1.331 1.331zm5.3239 0c-0.73507 0-1.331-0.5959-1.331-1.331 0-0.73507 0.5959-1.331 1.331-1.331 0.73507 0 1.331 0.5959 1.331 1.331 0 0.73507-0.5959 1.331-1.331 1.331zm5.3239 0c-0.73507 0-1.331-0.5959-1.331-1.331 0-0.73507 0.5959-1.331 1.331-1.331 0.73507 0 1.331 0.5959 1.331 1.331 0 0.73507-0.5959 1.331-1.331 1.331z" />
      </SvgIcon>
    )
  },
)

export default ThreeDotsCircle
